export default "__VITE_ASSET__DMKfz50w__"